import _ from 'lodash';
import type { Condition } from '../types/trident-campaigns';

// returns the list of conditions in the condition tree for which match function returns true
export function searchCondition(condition: Condition, match: Function) {
  const results = [];
  searchConditionHelper(condition, match, results);
  return results;
}

function searchConditionHelper(condition: Condition, match: Function, results: Array<Condition>) {
  if (match(condition)) {
    results.push(condition);
  }
  _.map(condition.conditions, c => {
    searchConditionHelper(c, match, results);
  });
}

export function createCityCondition(cityIds: Array) {
  return constructCondition('var.ride.pickupCityID', 'in', cityIds);
}

export function createTaxiTypeCondition(serviceIds: Array) {
  return constructCondition('var.ride.serviceID', 'in', serviceIds);
}

export function createCurrencyCondition(currency: string) {
  return constructCondition('var.payment.currency', 'eq', currency);
}

function constructCondition(lhs: string, operator: string, rhs: any) {
  return {
    lhs,
    operator,
    rhs,
  };
}
